<template>
  <div ref="mapContainer" style="width: 100%; height: 500px;"></div>
</template>

<script>
import { Loader } from "@googlemaps/js-api-loader";
import { onMounted, ref } from "vue";

export default {
  name: "GoogleMapLoader",

  props: {
    address: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const loader = new Loader({
      apiKey: "AIzaSyBw1I8IA9NeW0ECPKb3SZdp8uI3tdL_0OI",
      version: "weekly",
      libraries: ["places"],
    });

    const mapContainer = ref(null);
    let geocoder = null;
    let map = null;

    // Loading map from Google
    const loadMap = async (address) => {
      const { Map } = await loader.importLibrary("maps");
      const { AdvancedMarkerElement } = await loader.importLibrary("marker");
      const { Geocoder } = await loader.importLibrary("geocoding");

      geocoder = new Geocoder();

      geocoder.geocode({ address: address }, (results, status) => {
        if (status === "OK") {
          const location = results[0].geometry.location;

          map = new Map(mapContainer.value, {
            center: location,
            zoom: 14,
            mapId: "map_id",
          });

          new AdvancedMarkerElement({
            map: map,
            position: location,
            title: "Haxo",
          });
        } else {
          console.error("Géocodage échoué : " + status);
        }
      });
    };

    onMounted(() => {
      loadMap(props.address);
    });

    return {
      mapContainer,
      loadMap,
    };
  },
};
</script>